import React from "react"
import { Routes, Route, Link as RouterLink } from "react-router-dom"
import {
  AppBar,
  Box,
  Container,
  Drawer,
  IconButton,
  Link,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Toolbar,
  Typography
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"

import Home from "./home"
import Policy from "./privacy-policy"
import TermsOfSerive from "./terms-of-service"
import Eula from "./eula"
import CSAEPolicy from "./csae-policy"
import Support from "./support"
import EmailVerification from "./protected/email-verification"
import { tokens } from "./theme/tokens"
import appIcon from "./images/pngs/icon.png"

const navItems = [
  // { label: "How it works", href: "/#how-it-works" },
  // { label: "Events", href: "/#events" },
  // { label: "Why BroStrike", href: "/#why-brostrike" },
  // { label: "FAQ", href: "/#faq" },
  { label: "Support", href: "/support" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Service", href: "/terms-of-service" },
  { label: "EULA", href: "/eula" },
  { label: "CSAE Policy", href: "/csae-policy" }
]

const SiteHeader = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(open => !open)
  }

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backdropFilter: "blur(8px)",
          borderBottom: `2px solid ${tokens.colors.border}`,
          bgcolor: "background.default",
          color: tokens.colors.text.primary
        }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ py: 1.5, gap: 2 }}>
            <IconButton
              aria-label="open navigation"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { xs: "inline-flex", md: "none" }, mr: 1 }}
              color="inherit">
              <MenuIcon />
            </IconButton>

            <Stack
              component={RouterLink}
              to="/"
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{
                textDecoration: "none",
                color: "inherit",
                flexShrink: 0
              }}>
              <Box component="img" src={appIcon} alt="BroStrike icon" sx={{ width: 30, height: 30 }} />
              <Typography
                variant="h5"
                sx={{
                  fontFamily: tokens.typography.heading,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  color: "inherit"
                }}>
                BroStrike
              </Typography>
            </Stack>

            <Stack
              component="nav"
              direction="row"
              spacing={2}
              alignItems="center"
              aria-label="Primary"
              sx={{ display: { xs: "none", md: "flex" }, ml: 4, flexWrap: "wrap" }}>
              {navItems.map(item => (
                <Link
                  key={item.label}
                  component={RouterLink}
                  to={item.href}
                  underline="none"
                  sx={{
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    fontSize: "0.75rem",
                    borderBottom: "2px solid transparent",
                    transition: "border-color 0.2s ease",
                    "&:hover": {
                      borderColor: tokens.colors.accent.primary
                    }
                  }}>
                  {item.label}
                </Link>
              ))}
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{ display: { xs: "block", md: "none" } }}>
        <Box sx={{ width: 280, p: 2 }}>
          <Stack
            component={RouterLink}
            to="/"
            direction="row"
            spacing={1}
            alignItems="center"
            onClick={handleDrawerToggle}
            sx={{
              textDecoration: "none",
              color: tokens.colors.text.primary,
              mb: 2
            }}>
            <Box component="img" src={appIcon} alt="BroStrike icon" sx={{ width: 28, height: 28 }} />
            <Typography
              variant="h6"
              sx={{
                fontFamily: tokens.typography.heading,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "inherit"
              }}>
              BroStrike
            </Typography>
          </Stack>

          <List>
            {navItems.map(item => (
              <ListItemButton key={item.label} component={RouterLink} to={item.href} onClick={handleDrawerToggle}>
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
            <ListItemButton component={RouterLink} to="/#download" onClick={handleDrawerToggle}>
              <ListItemText primary="Download" />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
    </>
  )
}

const App = () => {
  return (
    <Box sx={{ bgcolor: "background.default", color: "text.primary", width: "100%", minHeight: "100vh" }}>
      <SiteHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy-policy" element={<Policy />} />
        <Route path="/terms-of-service" element={<TermsOfSerive />} />
        <Route path="/eula" element={<Eula />} />
        <Route path="/csae-policy" element={<CSAEPolicy />} />
        <Route path="__auth/*" element={<EmailVerification />} />
        {/* <Route path="/adhd" element={<AdminPanel />} /> */}
      </Routes>
    </Box>
  )
}

export default App
